import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { JIAMENG_GOODS_PATH, PROPERTY_OBJ } from '@constant'
import Table from './Table'
import Store from './store'
const store = new Store()
export default class extends Component {
  constructor(props) {
    super(props)
    store.setStoreData('id', props.params.id)
  }
  render() {
    let name = PROPERTY_OBJ[this.props.params.id]
    const header = [
      <Link to={JIAMENG_GOODS_PATH}>商品管理</Link>,
      <Link
        to={'/localMerchant/jiaMengGoods/weddingPhoto/' + this.props.params.id}
      >
        {name}
      </Link>,
      '添加直供商品'
    ]
    return (
      <HeaderView title="添加直供商品" header={header}>
        <Table store={store} />
      </HeaderView>
    )
  }
}
